import { useDataFetch } from './Use-data-fetch';

/**
 * Alertas e insights del dashboard administrativo.
 *
 * El gateway ya devuelve las filas con las etiquetas y colores que la tabla
 * usa (Critica/Advertencia/Informativa, Nueva/En seguimiento/Resuelta), así
 * que aquí no se traduce nada: lo que llega se pinta.
 */
export const useAlerts = ({
  page = 1,
  limit = 5,
  level,
  status,
  search,
} = {}) => {
  const { getData, patchData, postData, invalidateQuery } = useDataFetch();

  // Los filtros "Todos los ..." del select no viajan como filtro.
  const levelFilter = level && !level.startsWith('Todos') ? level : undefined;
  const statusFilter = status && !status.startsWith('Todos') ? status : undefined;

  const {
    data: alertsResponse,
    isLoading: alertsLoading,
    error: alertsError,
  } = getData(
    ['alerts', page, limit, levelFilter, statusFilter, search],
    '/alerts',
    {},
    {
      page,
      limit,
      level: levelFilter,
      status: statusFilter,
      search: search || undefined,
    }
  );

  const {
    data: summaryResponse,
    isLoading: summaryLoading,
    error: summaryError,
  } = getData(['alerts-summary'], '/alerts/summary');

  const {
    data: insightsResponse,
    isLoading: insightsLoading,
    error: insightsError,
  } = getData(['insights'], '/insights', {}, { limit: 20 });

  const updateStatusMutation = patchData('/alerts', {}, {
    onSuccess: () => {
      invalidateQuery(['alerts']);
      invalidateQuery(['alerts-summary']);
    },
  });

  // El endpoint es /alerts/:id/status; patchData arma la URL con body.id.
  const updateStatus = (id, status, note) =>
    updateStatusMutation.mutate({ id: `${id}/status`, status, note });

  const runMutation = postData('/alerts/run', {}, {
    onSuccess: () => {
      invalidateQuery(['alerts']);
      invalidateQuery(['alerts-summary']);
      invalidateQuery(['insights']);
    },
  });

  return {
    alerts: alertsResponse?.data?.items ?? [],
    pagination: alertsResponse?.data?.pagination ?? {
      page,
      limit,
      total: 0,
      totalPages: 1,
    },
    summary: summaryResponse?.data ?? null,
    insights: insightsResponse?.data?.items ?? [],
    insightsGeneratedAt: insightsResponse?.data?.generated_at ?? null,

    isLoading: alertsLoading || summaryLoading,
    insightsLoading,
    error: alertsError || summaryError,
    // Aparte del error general: si /insights falla, la tarjeta debe poder
    // decirlo. Mezclarlo con `error` tumbaría toda la vista de alertas por un
    // fallo que sólo afecta al panel lateral.
    insightsError,

    updateStatus,
    isUpdatingStatus: updateStatusMutation.isPending,

    runEngine: () => runMutation.mutate({}),
    isRunning: runMutation.isPending,
    runError: runMutation.error,
  };
};
